import { ProfileHeaderContainer, ProfileTitle } from "./ProfileHeader.styles";
import { ResourceBreadcrumb } from "./ResourceBreadcrumb";
import React from "react";
import { PaddedFlexBox } from "../../../ui/Flex";
import { Box } from "@material-ui/core";

export const ProfileHeader = ({
  organisationSlug,
  organisationName,
  resourceName,
  siteName,
  sites,
  slug,
}) => (
  <ProfileHeaderContainer>
    <PaddedFlexBox justifycontent="space-between">
      <ProfileTitle variant="h4">{resourceName}</ProfileTitle>
      {/* temporarily hardcoded logos till backend support */}

      {resourceName.includes("Clayfield") && (
        <Box position="absolute" right={0}>
          <img src={`/logos/radian.png`} height="75px" />
        </Box>
      )}
      {resourceName.includes("St John's Grammar Junior Campus") && (
        <Box position="absolute" right={0} marginTop={1.5}>
          <img src={`/logos/zen.png`} height="35px" />
        </Box>
      )}
    </PaddedFlexBox>
    <ResourceBreadcrumb
      organisationName={organisationName}
      organisationSlug={organisationSlug}
      resourceName={resourceName}
      siteName={siteName}
      sites={sites}
      slug={slug}
    />
  </ProfileHeaderContainer>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/ProfileHeader/ProfileHeader.js